<template>
  <v-main>
    <v-container>
      <v-row class="mb-3">
        <v-col cols="12">
          <div class="container-icons">
            <div style='display: flex; justify-content: center; gap: 3px; align-items: center;'>
              <div class='' style='border: solid black 1px; gap: 4px;'>
                <svg width="20px" height="20px" viewbox="0 0 20 20" style="font-family: Arial, sans-serif">
                  <path fill-opacity="0" stroke="#000000" stroke-width="1" d="M1,10 10,1 19,10 10,19 1,10"
                    class="white-stroke"></path>
                </svg>
              </div>
              <span>Hazardous</span>
            </div>
            <div style='display: flex; justify-content: center; gap: 3px; align-items: center;'>
              <div class=''
                style='border: solid black 1px; height: 24px; width: 24px; gap: 4px; display: flex; justify-content: center; align-items: center;'>
                <span>e</span>
              </div>
              <span>Empty</span>
            </div>
            <div style='display: flex; justify-content: center; gap: 3px; align-items: center;'>
              <div class=''
                style='border: solid black 1px; height: 24px; width: 24px; gap: 4px; display: flex; justify-content: center; align-items: center;'>
                <span>r</span>
              </div>
              <span>Reefer</span>
            </div>
            <div style='display: flex; justify-content: center; gap: 3px; align-items: center;'>
              <div class=''
                style='border: solid black 1px; height: 24px; width: 24px; gap: 4px; display: flex; justify-content: center; align-items: center;'>
                <svg width="20px" height="20px" viewbox="0 0 20 20" style="font-family: Arial, sans-serif">
                  <path transform="translate(10, -3)" fill="#000" stroke-width="0" d="M0,8 5,3 10,8"></path>
                </svg>
              </div>
              <span>High-cube</span>
            </div>
            <div style='display: flex; justify-content: center; gap: 3px; align-items: center;'>
              <div class=''
                style='position: relative; border: solid black 1px; height: 24px; width: 24px; gap: 4px; display: flex; justify-content: center; align-items: center;'>
                <svg style='position: absolute; top: 0; left: 0;' width="20px" height="20px" viewbox="0 0 20 20">
                  <path fill="#000" stroke-width="0" d="M0,0 9,0 9,3 0,3 0,0"></path>
                </svg>
              </div>
              <span>40-footer</span>
            </div>
            <div style='display: flex; justify-content: center; gap: 3px; align-items: center;'>
              <div class=''
                style='position: relative; border: solid black 1px; height: 24px; width: 24px; gap: 4px; display: flex; justify-content: center; align-items: center;'>
                <svg width="20px" height="20px" viewbox="0 0 20 20" style='position: absolute; top: 0; left: 0;'>
                  <path fill="#000" stroke-width="0" d="M0,0 9,0 A 9 9, 0, 0, 1, 0 9 L0,0 Z"></path>
                </svg>
              </div>
              <span>45-footer</span>
            </div>
            <!-- Add more container property icons as needed -->
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="(vesselHatch, index) in vesselMonitoringData?.vesselHatches" :key="`all-monitoring-bay-${index}`" >
          <vessel-monitoring-hatch :vesselHatch='vesselHatch' :minDeckTiersNo="vesselMonitoringData?.minDeckTierNo"
          :minHoldTiersNo="vesselMonitoringData?.minHoldTierNo"></vessel-monitoring-hatch>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import VesselMonitoringBay from '@/view/pages/vesselMonitoring/components/VesselMonitoringBay/VesselMonitoringBay.vue'
import VesselMonitoringHatch from '../VesselMonitoringBay/VesselMonitoringHatch.vue';
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    VesselMonitoringBay,
    VesselMonitoringHatch,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters(["getVesselMonitoringData"]),
    
    vesselMonitoringData() {
      return this.getVesselMonitoringData;
    }
  },
  mounted() {
  },
}
</script>

<style scoped>
.container-type-legend {
display: flex;
gap: 1rem;
justify-content: center;
align-items: center;
}

.container-type-legend v-badge {
margin-right: 10px;
}

.container-icons {
display: flex;
justify-content: center;
align-items: center;
gap: 2rem;
flex-wrap: wrap;
}

.container-icons v-icon {

font-size: 18px;
margin-right: 10px;
}

.container-type-legend v-badge[color="red"]::before {
background-color: red;
}

.container-type-legend v-badge[color="grey"]::before {
background-color: grey;
}

.container-type-legend v-badge[color="blue"]::before {
background-color: blue;
}
</style>

